import { render, staticRenderFns } from "./iamcertificate.vue?vue&type=template&id=1120dada&scoped=true&"
import script from "./iamcertificate.vue?vue&type=script&lang=js&"
export * from "./iamcertificate.vue?vue&type=script&lang=js&"
import style0 from "./iamcertificate.vue?vue&type=style&index=0&id=1120dada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1120dada",
  null
  
)

export default component.exports